<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.8356047600964!2d115.22213841478491!3d-8.801510793678855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDgnMDUuNCJTIDExNcKwMTMnMjcuNiJF!5e0!3m2!1sen!2sid!4v1583936365100!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.8015108,115.2243271/@-8.8015108,115.2221384,17z/data=!4m2!4m1!3e0?hl=en"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/erik-krisna/SKF_9739_JTKXx-uR1l.jpg?tr=w-1024'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/erik-krisna/SKF_9785_TWGTZDipi.jpg?tr=w-1024'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/erik-krisna/SKP_6518_wyaJnHncQ.jpg?tr=w-1024'

import Audio from "@/assets/audio/all-of-the-above.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      wedding: {
        man: {
          name: 'dr. I Wayan Erik Pramana Jaya, S.Ked',
          surname: 'Erik',
          parents: 'I Ketut Wijaya, Amd. Kep & Ni Luh Murni',
          description: 'Putra pertama',
          address: 'Br. Penyarikan, Nusa Dua, Kab. Badung - Bali',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/erik-krisna/SKF_9851_l4pNVQoRQ.jpg?tr=w-400',
        },
        woman: {
          name: 'dr. Ni Luh Krisna Agustini, S.Ked',
          surname: 'Krisna',
          parents: 'I Nyoman Sulendra, SE & Ni Wayan Purni',
          address: 'Kedonganan, Kec. Kuta, Kab. Badung - Bali',
          description: 'Putri pertama',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/erik-krisna/SKP_6548_pxhZ74iwZ.jpg?tr=w-400',
        },
      },
      location: "Jl. Srikandi, Gg.Ramayana, No.9B, link. Br. Penyarikan - Nusa Dua",
      time: {
        start: this.$moment("2020-11-06 15:00"),
        end: "Selesai"
      },
      mepandes: [
        'dr. I Wayan Erik Pramana Jaya, S.Ked',
        'Ni Made Alya Rosita',
        'Ni Luh Rianingsih, S.Pd',
        'Agus Yoga Mandyka, Amd.Par',
        'Bayu Yogi Wedananta',
        'I Komang Basudewa Suputra',
        'I Putu Aldy Candra Dinata',
        'I Kadek Rikho Sujana',
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
      this.sw.refreshing = true;
      window.location.reload();
    }
  }
};
</script>
